import { productsSlugs } from 'constants/products';

import serumDesktop from 'assets/images/hairDensityLP/densityLP-serum-desktop.jpg';
import serumMobile from 'assets/images/hairDensityLP/densityLP-serum-mobile.jpg';
import supplementsDesktop from 'assets/images/hairDensityLP/densityLP-supplements-desktop.jpg';
import supplementsMobile from 'assets/images/hairDensityLP/densityLP-supplements-mobile.jpg';
import acai from 'assets/images/homeRevamp/ingredients/0-acai.png';
import biotin from 'assets/images/homeRevamp/ingredients/3-biotin.png';
import acerola from 'assets/images/ingredients/acerola.png';
import aniseed from 'assets/images/ingredients/aniseed-myrtle-extract.png';
import corianderOil from 'assets/images/ingredients/coriander-oil.png';
import dogRoseFruit from 'assets/images/ingredients/dog-rose-fruit.png';
import jujubeBarkExtract from 'assets/images/ingredients/jujube-bark-extract.png';
import kombucha from 'assets/images/ingredients/kombucha.png';
import macaRoot from 'assets/images/ingredients/maca-root.png';
import redAlgae from 'assets/images/ingredients/red-algae.png';
import riceProtein from 'assets/images/ingredients/rice-protein.png';
import rosemary from 'assets/images/ingredients/rosemary.png';
import beforeAndAfterFulnessDesktop from 'assets/images/landingPages/densitySet/density-set-before-after-hair-fullness-desktop-1x.jpg';
import beforeAndAfterFulnessMobile from 'assets/images/landingPages/densitySet/density-set-before-after-hair-fullness-mobile-2.5x.jpg';
import beforeAndAfterGrowthDesktop from 'assets/images/landingPages/densitySet/density-set-before-after-hair-growth-desktop-1x.jpg';
import beforeAndAfterGrowthMobile from 'assets/images/landingPages/densitySet/density-set-before-after-hair-growth-mobile-2.5x.jpg';
import densitySetHowItWorksPicture from 'assets/images/landingPages/densitySet/prose-custom-scalp-serum-in-use.jpg';
import purecatalystImg from 'assets/images/productPages/ingredients/purecatalyst.png';

export const stepSupplements = {
  step: 'step 1',
  link: '/products/custom-hair-supplements',
  title: (
    <>
      Custom Root Source<sup>®</sup> Hair Supplements
    </>
  ),
  subtitle: 'One month supply. Two daily capsules.',

  body: 'Nurture growth from within. Our plant-based hair supplements are personalized to help you boost hair growth and target your unique scalp needs — all in 2 daily capsules.',
  numbers: [
    { key: 'saw improved hair growth', result: 93 },
    { key: 'saw reduced hair breakage', result: 90 },
    { key: 'saw reduced hair shedding', result: 91 },
  ],

  tooltip:
    '‡Results of a 3-month in-house study of Prose 2-step hair growth program performed on 69 subjects. Results may vary. Double-blind clinical study vs. placebo related to our proprietary blend performed on 60 subjects during 12 weeks.',
  image: {
    mobile: supplementsMobile,
    desktop: supplementsDesktop,
    alt: 'Prose Custom Root Source® Hair Supplements with glass of water',
  },
  slug: productsSlugs.SUPPLEMENT_CORE,
};

export const stepSerum = {
  step: 'step 2',
  link: '/products/custom-scalp-serum',
  title: 'Custom Scalp Serum',
  subtitle: '1.7 fl oz  50 mL',

  body: 'Healthy hair starts at the scalp. Our lightweight leave-on scalp serum promotes optimal scalp health for hair that looks and feels fuller, denser, and more voluminous. For best results, use daily.',
  numbers: [
    { key: 'agreed their scalp felt nourished', result: 89 },
    { key: 'agreed their scalp felt more comfortable', result: 87 },
    { key: 'agreed their scalp felt healthier', result: 81 },
  ],

  tooltip:
    'Based on self-assessment in a 4-week use-test of 97 subjects who used Prose Custom Scalp Serum daily.',
  image: {
    mobile: serumMobile,
    desktop: serumDesktop,
    alt: 'Prose Custom Scalp Serum bottle with flower',
  },
  slug: productsSlugs.SCALP_SERUM,
};

export const scienceTeam = {
  title: 'Developed by experts, backed by science',
  description:
    'The Custom Hair Density Set is developed by our world-class team of in-house cosmetic chemists and rigorously tested for safety and efficacy.',
};

export const ingredientsSlider = {
  titleBlock: {
    title: 'Powered by 99% natural ingredients',
    subtitle:
      'Your formula is uniquely yours. We’ll target your goals and concerns with a powerful blend of only the clean, clinically tested ingredients you need.',
  },
  sliderCardsContent: [
    {
      ingredientName: 'PureCatalyst™',
      subtitle: 'in Hair Supplements',
      description: 'to stimulate hair growth from within',
      img: { imgSrc: purecatalystImg, imgAlt: 'PureCatalyst to stimulate hair growth from within' },
    },
    {
      ingredientName: 'Rosemary Extract',
      subtitle: 'in Scalp Serum',
      description: 'to support hair health and scalp vitality',
      img: {
        imgSrc: rosemary,
        imgAlt: 'Rosemary extract to support hair health and scalp vitality',
      },
    },
    {
      ingredientName: 'Hyaluronic Acid',
      subtitle: 'in Scalp Serum',
      description: 'to hydrate stressed, dry scalps',
      img: { imgSrc: acai, imgAlt: 'Hyaluronic acid for skin hydration and moisture barrier' },
    },
    {
      ingredientName: 'Biotin',
      subtitle: 'in Hair Supplements',
      description: 'to nourish and promote stronger, fuller hair',
      img: { imgSrc: biotin, imgAlt: 'Biotin to enhance hair strength and density' },
    },
    {
      ingredientName: 'Maca Root',
      subtitle: 'in Scalp Serum',
      description: 'to promote hair density and strength',
      img: { imgSrc: macaRoot, imgAlt: 'Maca root to promote hair density and strength' },
    },
    {
      ingredientName: 'Acerola Extract',
      subtitle: 'in Hair Supplements',
      description: 'to fight oxidative stress and support collagen',
      img: {
        imgSrc: acerola,
        imgAlt: 'Acerola extract to fight oxidative stress and support collagen',
      },
    },
    {
      ingredientName: 'Rice Peptides',
      subtitle: 'in Scalp Serum',
      description: 'to help improve the appearance of thinning hair',
      img: {
        imgSrc: riceProtein,
        imgAlt: 'Rice peptides to help improve the appearance of thinning hair',
      },
    },
    {
      ingredientName: 'Coriander Seed Oil',
      subtitle: 'in Hair Supplements',
      description: 'to help soothe and reduce scalp sensitivity',
      img: {
        imgSrc: corianderOil,
        imgAlt: 'Coriander seed oil to help soothe and reduce scalp sensitivity',
      },
    },
    {
      ingredientName: 'Kombucha Tea',
      subtitle: 'in Scalp Serum',
      description: 'to promote the scalp’s microbiome balance',
      img: {
        imgSrc: kombucha,
        imgAlt: 'Kombucha tea to promote the scalp’s microbiome balance',
      },
    },
    {
      ingredientName: 'Aniseed Myrtle Extract',
      subtitle: 'in Scalp Serum',
      description: 'to help calm and soothe scalp discomfort',
      img: {
        imgSrc: aniseed,
        imgAlt: 'Aniseed myrtle extract to help calm and soothe scalp discomfort',
      },
    },
    {
      ingredientName: 'Dog Rose Fruit Extract',
      subtitle: 'in Scalp Serum',
      description: 'to balance oily scalps and keep hair cleaner for longer',
      img: {
        imgSrc: dogRoseFruit,
        imgAlt: 'Dog rose fruit extract to balance oily scalps and keep hair cleaner for longer',
      },
    },
    {
      ingredientName: 'Red Algae Extract',
      subtitle: 'in Scalp Serum',
      description: 'to protect against pollution + environmental stressors',
      img: {
        imgSrc: redAlgae,
        imgAlt: 'Red algae extract to protect against pollution and environmental stressors',
      },
    },
    {
      ingredientName: 'Jujube Bark Extract',
      subtitle: 'in Scalp Serum',
      description: 'to help control flaky scalps and soothe irritation',
      img: {
        imgSrc: jujubeBarkExtract,
        imgAlt: 'Jujube bark extract to help control flaky scalps and calm irritation',
      },
    },
  ],
};

export const faq = {
  questions: [
    {
      question:
        'What is the difference between the Custom Scalp Serum and Custom Root Source® Hair Supplements and how do they work together?',
      answer: (
        <>
          Simply put, Root Source® Hair Supplements promote hair growth from the inside-out, while
          Custom Scalp Serum nourishes hair and scalp health from the outside-in. When paired
          together and used consistently, the benefits compound over time.
          <br />
          <br />
          Designed for daily application, Prose Custom Scalp Serum treats at the root, offering
          continuous support for the scalp, helping to maintain hydration, soothe irritation, and
          promote fuller, thicker hair. As a leave-on product, it remains on the scalp throughout
          the day or night, allowing its clinically tested ingredients to penetrate deeply and work
          consistently.
        </>
      ),
    },
    {
      question: 'How soon will I see results using both?',
      answer: (
        <>
          This will vary for each individual, but those with sensitivities can expect to experience
          immediate soothing. Within a few weeks of use, your scalp should feel more balanced and
          hair should start feeling softer. After a month, you can expect a healthier scalp,
          stronger hair, and the beginnings of hair that looks and feels fuller, denser, and more
          voluminous. After three months of use, you may notice new baby hairs forming; stay
          committed, and after six months you’ll continue to see the results of new hair growth.*
          Results may vary.
          <br />
          <br />
          If for any reason you’re not completely satisfied with the results of your Custom Scalp
          Serum, you can <a href="https://prose.com/faq">contact The Pros</a> — your support team of
          custom haircare experts.
        </>
      ),
    },
    {
      question: 'How should I take my Custom Root Source® Supplements?',
      answer: (
        <>
          Take one capsule from each Root Source® jar daily, with water (and food if you have a
          sensitive stomach). Consistency is key, so aim to take daily without skipping any doses.
          <br />
          <br />
          If your capsules look a little cloudy it’s completely normal. Root Source® is made
          without any synthetic fillers or dyes, so what you’re seeing is natural. The actives may
          separate into their crystalline forms, making spots of the capsule appear cloudy, but this
          has no impact on the formulas’ freshness or potency.
        </>
      ),
    },
    {
      question: 'Do these products help to achieve fuller, denser hair?',
      answer:
        'Yes — the Custom Hair Density Set is designed as a simple, 2-step system to promote scalp care and hair health, fullness, and density from inside and out. Powerful alone and transformative together, each formula in the set is personalized to meet your specific needs, with targeted ingredients to help common concerns such as dry scalp, hair loss, flakiness, itchiness, and more.',
    },
    {
      question:
        'Will the Custom Hair Density Set meet my Prose ingredient preferences? What if I have an ingredient concern?',
      answer: (
        <>
          All Root Source® and Custom Scalp Serum formulas are vegan, GMO-free, and 99% natural as
          standard. Root Source® are gluten-free through the use of gluten-free wheat extract and
          also free from: soy, nuts, hormone disruptors, drug ingredients, synthetic fillers,
          artificial flavors, and artificial coloring.
          <br />
          <br />
          You can view a full list of your ingredients in your shopping cart before checkout, but
          please note that we cannot add or remove ingredients from your supplement formulas. If you
          are pregnant, nursing, have a health condition or are taking medication, please consult
          with your doctor before taking Root Source®.
          <br />
          <br />
          If you have any specific ingredient or allergy concerns, please send us a note via our
          contact form{' '}
          <a href="https://prose.com/faq/contact-us" target="_blank">
            here
          </a>
          .
        </>
      ),
    },
    {
      question: 'Will the Custom Hair Density Set work for my specific hair type and texture?',
      answer: (
        <>
          Yes — like all Prose hair and skin formulas, your Custom Hair Density Set will be
          personalized to 85+ factors from your in-depth consultation and will work on straight
          (type 1), wavy (type 2), curly (type 3) and coily (type 4) hair.
          <br />
          <br />
          We account for everything from your hair density, porosity, and texture to what you eat
          and the weather and water where you live, so your hair can get the exact care that it
          needs.
          <br />
          <br />
          We also ensure our products are tested on a full range of hair types, including type 3 and
          type 4 — hair types often overlooked by traditional mass-produced beauty brands.
        </>
      ),
    },
    {
      question: 'How long will each bottle last?',
      answer: (
        <>
          Every order of Custom Root Source® Hair Supplements contains a 30-day supply of 2
          capsules (60 capsules total). Your first order will arrive in sustainable glass jars with
          your name on them. After that, we’ll send your custom hair supplements in pouches made of
          100% compostable materials, so you can reuse your original bottles with every order.
          <br />
          <br />
          When applied daily as directed, your Custom Scalp Serum bottle is designed to last 1
          month. To help minimize waste, we recommend reusing your dropper with your subsequent
          orders.
        </>
      ),
    },
    {
      question: 'Will the two products in the Custom Hair Density Set ship together?',
      answer: (
        <>
          Your first order of Custom Scalp Serum and Hair Supplements will ship together. Subsequent
          subscription orders will ship on slightly different cadences:
          <br />
          <br />
          <b>Hair Supplements</b> ship every 25 days to ensure you never miss a dose.
          <br />
          <br />
          <b>Scalp Serum</b> ships every 4, 8, or 12 weeks, based on your selected frequency.
        </>
      ),
    },
  ],
};

export const ticker = [
  'certified microbiome-friendly',
  'vegan',
  'cruelty free',
  '100% drug free',
  'silicone free',
  'alcohol free',
  'sulfate free',
  'free of gmos',
  'free of hormone disruptors',
  'free of synthetic additives',
  'toxicologist-approved',
  'traceable ingredients',
  'carbon neutral',
];

export const howToUse = {
  title: ' How to use',
  description:
    'Consistency is key. We recommend 3+ months of daily use to see results. Pair Root Source® and Custom Scalp Serum at night for a simple and soothing before-bed ritual. ',
  amount: '2 daily capsules + 2 to 3 droppers of serum',
  steps: [
    'Take one capsule from each Root Source® jar daily, with water.',
    'Next, apply 2 to 3 full droppers of serum directly to a dry or damp scalp. Focus on areas of concern and gently massage with your fingertips to distribute.',
    'Do not rinse. Style hair as usual.',
  ],
  video: 'density-set-how-it-works',
  posterImage: densitySetHowItWorksPicture,
};

export const beforeAndAfterContent = {
  hairResults: [
    {
      header: {
        title: 'hair growth',
        dataClick: 'HAIR GROWTH',
        dataFrom: 'before-after-module-carousel',
      },
      title: (
        <>
          Visible growth in 90 days with <b>Custom Root Source® Hair Supplements</b>
          <sup>†</sup>
        </>
      ),
      image: {
        desktop: beforeAndAfterGrowthDesktop,
        mobile: beforeAndAfterGrowthMobile,
      },
      imageAlt: 'See hair growth results using Prose Custom Root Source® Hair Supplements',
      disclaimer: (
        <>
          <sup>†</sup>Individual results from a paid partner after 3 months of using Prose Root
          Source daily. Results may vary.
        </>
      ),
    },
    {
      header: {
        title: 'hair fullness',
        dataClick: 'HAIR FULLNESS',
        dataFrom: 'before-after-module-carousel',
      },
      title: (
        <>
          Boosted hair density and fullness in 90 days with <b>Custom Scalp Serum</b>
          <sup>†</sup>
        </>
      ),
      image: {
        mobile: beforeAndAfterFulnessMobile,
        desktop: beforeAndAfterFulnessDesktop,
      },
      imageAlt: 'See soothed scalp results using Prose Custom Scalp Serum',
      disclaimer: (
        <>
          <sup>†</sup>Individual results from a use-test participant after 3 months of using Prose
          Custom Scalp Serum daily. Results may vary.
        </>
      ),
    },
  ],
};
